/*!
 * Copyright 2018 acrazing <joking.young@gmail.com>. All rights reserved.
 * @since 2018-06-27 00:25:38
 */
import { __assign } from 'tslib';
import { inject } from './inject';
import { KeyFormat, KeyIgnores, KeyNodeVersion, KeyVersions } from './keys';
export function format(deserializer, serializer) {
  return function (target, propertyKey) {
    inject(target, KeyFormat);
    target[KeyFormat][propertyKey] = {
      deserializer: deserializer,
      serializer: serializer
    };
  };
}
export var date = format(function (value) {
  return new Date(value);
});
export var regexp = format(function (value) {
  return new RegExp(value.source, value.flags);
}, function (value) {
  return {
    flags: value.flags,
    source: value.source
  };
});
export function ignore(target, propertyKey) {
  inject(target, KeyIgnores);
  target[KeyIgnores][propertyKey] = true;
}
export function version(value) {
  return function (target, key) {
    if (key === void 0) {
      key = KeyNodeVersion;
    }

    if (typeof target === 'function') {
      target = target.prototype;
    }

    inject(target);

    if (!target.hasOwnProperty(KeyVersions)) {
      target[KeyVersions] = __assign({}, target[KeyVersions] || {});
    }

    target[KeyVersions][key] = value;
  };
}